import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["refresh"]

  connect() {
    this.handleInboxRowUpdate = this.handleInboxRowUpdate.bind(this)
    this.highlightCurrent = this.highlightCurrent.bind(this)
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    document.addEventListener("whatsapp:inbox-row-update", this.handleInboxRowUpdate)
    document.addEventListener("turbo:frame-load", this.handleFrameLoad)
    this.observer = new MutationObserver(() => this.highlightCurrent())
    this.observer.observe(this.element, { childList: true })
    this.highlightCurrent()
    this.syncOpenState()
  }

  disconnect() {
    document.removeEventListener("whatsapp:inbox-row-update", this.handleInboxRowUpdate)
    document.removeEventListener("turbo:frame-load", this.handleFrameLoad)
    this.observer?.disconnect()
  }

  refresh() {
    window.location.reload()
  }

  handleInboxRowUpdate(event) {
    if (event.detail.list !== this.element || this.nearTop()) return

    event.preventDefault()
    this.refreshTarget.hidden = false
  }

  nearTop() {
    return this.element.getBoundingClientRect().top >= -80
  }

  highlightCurrent() {
    const match = window.location.pathname.match(/\/whatsapp\/conversations\/(\d+)/)
    const id = match?.[1]

    this.element.querySelectorAll("[data-conversation-id]").forEach((row) => {
      const link = row.querySelector("a")
      const selected = Boolean(id) && row.dataset.conversationId === id
      link?.classList.toggle("bg-[#f0f2f5]", selected)
      if (!link) return

      if (selected) {
        link.setAttribute("aria-current", "page")
      } else {
        link.removeAttribute("aria-current")
      }
    })
  }

  handleFrameLoad(event) {
    if (event.target.id !== "whatsapp_inbox_thread") return

    this.highlightCurrent()
    this.syncOpenState()
  }

  syncOpenState() {
    const shell = this.element.closest(".whatsapp-inbox-shell")
    if (!shell) return

    const open = /\/whatsapp\/conversations\/\d+/.test(window.location.pathname)
    shell.classList.toggle("is-open", open)
  }
}
